import { ON_ASSISTANT_ENDED_EVENT_TYPE } from 'core/constants';
import { ChatSessionsData } from 'core_main/api/sessions/types';
import { runListenersForEvent } from 'core_main/globals/events';
import { ConversationCallbackResponse } from 'core_main/sdk/types';
import { PubNubSessionEndMessageEvent } from '../types';

export const createEndAssistantCallbackResponse = (
  data: ChatSessionsData,
): ConversationCallbackResponse => {
  const { id: conversationId } = data;
  const { isInAssistantMode } = data.attributes;
  return {
    conversationId,
    isInAssistantMode,
  };
};

export const handleAssistantSessionEndedEvent = (
  message: PubNubSessionEndMessageEvent,
) => {
  const callbackResponse = createEndAssistantCallbackResponse(message.data);

  runListenersForEvent(ON_ASSISTANT_ENDED_EVENT_TYPE, callbackResponse);
};
